var _rect, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGradu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 116,
    viewBox: "0 0 119 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 119,
    height: 116,
    rx: 15,
    fill: "#E6F3FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.7177 55.5441V58.5042C87.7177 62.1831 84.7354 65.1654 81.0565 65.1654C77.3779 65.1654 74.3956 62.1831 74.3956 58.5042V55.5441L79.0276 57.6027C80.3194 58.1769 81.7939 58.1769 83.0857 57.6027L87.7177 55.5441ZM70.2325 53.6938V61.0023C70.2325 61.6923 69.6733 62.2515 68.9833 62.2515C68.2936 62.2515 67.7344 61.6923 67.7344 61.0023V52.582C67.7497 52.5899 67.7653 52.5973 67.7812 52.6044L70.2325 53.6938Z",
    fill: "#0044EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3343 52.3157L83.0879 47.3173C81.7961 46.7432 80.3216 46.7432 79.0298 47.3173L67.7834 52.3157C67.1243 52.6087 67.1243 53.5444 67.7834 53.8375L79.0298 58.8358C80.3216 59.41 81.7961 59.41 83.0879 58.8358L94.3343 53.8375C94.9937 53.5444 94.9937 52.6087 94.3343 52.3157Z",
    fill: "#0044EB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.9512 79.7197H91.0451C92.8847 79.7197 94.3757 78.2287 94.3757 76.3891C94.3757 72.7804 91.1171 69.6766 86.4458 68.3029C85.8881 68.1391 85.2917 68.3152 84.8831 68.7283L82.2377 71.4031C81.5858 72.0622 80.5214 72.0622 79.8695 71.4031L77.2244 68.7283C76.8155 68.3152 76.2191 68.1391 75.6614 68.3029C74.0249 68.7841 72.5621 69.4777 71.3516 70.3309C74.2352 72.9697 75.9395 76.2127 75.9512 79.7197Z",
    fill: "#0044EB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.3521 48.6242V53.1405C62.3521 58.7526 57.8026 63.3021 52.1905 63.3021C46.5783 63.3021 42.0288 58.7526 42.0288 53.1405V48.6242L49.0952 51.7649C51.0658 52.6407 53.3152 52.6407 55.2858 51.7649L62.3521 48.6242ZM35.6778 45.8015V56.9511C35.6778 58.0035 34.8248 58.8564 33.7725 58.8564C32.7202 58.8564 31.8672 58.0035 31.8672 56.9511V44.1055C31.8903 44.1174 31.9141 44.1288 31.9384 44.1396L35.6778 45.8015Z",
    fill: "#0044EB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4381 41.8173L55.2814 34.192C53.3108 33.3162 51.0614 33.3162 49.0908 34.192L31.934 41.8173C30.9282 42.2643 30.9282 43.6917 31.934 44.1387L49.0908 51.764C51.0614 52.6398 53.3108 52.6398 55.2814 51.764L72.4381 44.1387C73.444 43.6917 73.444 42.2643 72.4381 41.8173Z",
    fill: "#0044EB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3409 66.8589L50.3764 70.9395C51.3707 71.9448 52.9947 71.9448 53.989 70.9395L58.0246 66.8589C58.648 66.2286 59.5579 65.9598 60.4087 66.21C67.5349 68.3055 72.5059 73.0404 72.5059 78.5457C72.5059 81.3519 70.2313 83.6265 67.4251 83.6265H36.9402C34.1342 83.6265 31.8594 81.3519 31.8594 78.5457C31.8594 73.0404 36.8306 68.3055 43.9568 66.21C44.8074 65.9598 45.7175 66.2286 46.3409 66.8589Z",
    fill: "#0044EB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradu);
export default __webpack_public_path__ + "static/media/gradu.d0c4e3fe231267b3774b86f3b349df4d.svg";
export { ForwardRef as ReactComponent };